import { render, staticRenderFns } from "./pointChart.vue?vue&type=template&id=29320249&scoped=true"
import script from "./pointChart.vue?vue&type=script&lang=js"
export * from "./pointChart.vue?vue&type=script&lang=js"
import style0 from "./pointChart.vue?vue&type=style&index=0&id=29320249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29320249",
  null
  
)

export default component.exports